module.exports = __webpack_public_path__ + "img/senryuGame1.c8512dab.png";